import React from 'react'
import { numberNotation } from '../../../utils/safe'
import { Imballi } from '../../atoms/NewIcons'
import Alert from '../../atoms/Alert/Alert'
import Trans from '../../atoms/Trans/Trans'
import useTrans from '../../../hooks/useTrans'
import Link from 'next/link'
import { Button } from '../../atoms'

const InfoQuantita = ({
  service_gift,
  articolo,
  prodotto,
  personalizzazioni,
  imballi,
  sotto_imballi,
  handleVisualizzaImballi,
}) => {
  const t = useTrans()
  return (
    <div className="info__quantita">
      {/* <div className="info__quantita__head">
        <h2 className="info__quantita__title">
          {t('Inserisci la quantità e procedi con l’ordine')}
        </h2>
        {(!service_gift || service_gift?.premium) && (
          <p className="info__quantita__label">
            {service_gift && !service_gift.personalizzazione ? (
              <Trans chiave="Inserisci le quantità dei prodotti che desideri aggiungere al preventivo" />
            ) : (
              <Trans
                chiave="Inserisci le quantità dei prodotti che desideri personalizzare e/o aggiungere al
            preventivo"
              />
            )}
          </p>
        )}
      </div> */}

      {articolo?.acquistabile_multipli ? (
        <Alert
          full
          variant="info"
          placeholder={t('Articolo acquistabile solo a multipli di {0} pezzi', [
            articolo?.acquistabile_multipli,
          ])}
          className="info__quantita__multipli-alert"
        />
      ) : null}

      <div className="info__quantita__wrapper">
        <p>
          *{t("Le immagini sono a scopo illustrativo. Il colore del prodotto potrebbe variare in base alla produzione.")}
        </p>
        {prodotto?.personalizzabile &&
          personalizzazioni?.tecniche?.length > 0 &&
          prodotto?.quantita_minima_personalizzabile &&
          (!service_gift || service_gift?.personalizzazione) && (
            <p>
              <Trans chiave="*Quantità minima personalizzabile:" />{' '}
              <strong>{numberNotation(prodotto?.quantita_minima_personalizzabile)}</strong>{' '}
              <Trans chiave="pezzi" />
            </p>
          )}
        {!service_gift?.attivo && (
          <p>
            <strong>
              <Trans chiave="*Sconto extra del 2%" />
            </strong>{' '}
            <Trans chiave="se mantieni gli imballi" />{': '}
            <strong>{articolo.imballi}</strong>{' '}
            <Trans chiave="pezzi" />
            {articolo.sotto_imballi && articolo.sotto_imballi > 0 ? (
              <>
                {' '}<Trans chiave="e/o sottoimballi" />{': '}
                <strong>{articolo.sotto_imballi}</strong>{' '}
                <Trans chiave="pezzi" />
              </>
            ) : null}
          </p>
        )}

        {service_gift && service_gift?.attivo && (
          <p>
            {service_gift.frase_supplementi_minimi ? (
              <Trans chiave="*Puoi personalizzare anche quantitativi inferiori, nel preventivo verrà calcolato un supplemento" />
            ) : (
              <>
                <Trans chiave="*Desideri personalizzare quantitativi inferiori?" />{' '}
                <Link legacyBehavior href="/contatti">
                  <a>
                    <Trans chiave="Contattaci" />
                  </a>
                </Link>
              </>
            )}
          </p>
        )}
      </div>

      <div className="prodotto__buttons__wrapper">
        <Button
          label={t('Vedi informazioni imballi')}
          variant="ghost"
          icon={<Imballi />}
          icon_pos={'left'}
          onClick={() => handleVisualizzaImballi()}
        />
      </div>

      {/* <div className="info__imballi">
        <div className="info__imballi__quantita">
          {sotto_imballi > 0 && (
            <span className="info__imballi__quantita-item">
              <span className="info__imballi__quantita-icon">
                <Imballi />
              </span>
              <span className="info__imballi__quantita-label">
                <strong>{sotto_imballi}</strong> <Trans chiave="pezzi per sotto imballi" />
              </span>
            </span>
          )}
          {imballi > 0 && (
            <span className="info__imballi__quantita-item">
              <span className="info__imballi__quantita-icon">
                <Imballi />
              </span>
              <span className="info__imballi__quantita-label">
                <strong>{imballi}</strong> <Trans chiave="pezzi per imballi" />
              </span>
            </span>
          )}
        </div>
      </div> */}
    </div>
  )
}

export default InfoQuantita
